/**
 * Exercise Type Configurations
 * 
 * This module exports all exercise type configs and registers them
 * with the central registry.
 */

import { exerciseRegistry } from '../registry';
import { multipleChoiceConfig } from './multiple-choice';
import { fillInBlankConfig } from './fill-in-blank';
import { selectForBlankConfig } from './select-for-blank';
import { matchingConfig } from './matching';
import { scrambleConfig } from './scramble';
import { longAnswerConfig, shortAnswerConfig } from './written';
import { recordedConfig } from './recorded';
import { conversationalConfig } from './conversational';
import { fileUploadConfig } from './file-upload';

// Export individual configs
export { multipleChoiceConfig } from './multiple-choice';
export { fillInBlankConfig, formatAcceptedAnswers } from './fill-in-blank';
export { selectForBlankConfig } from './select-for-blank';
export { matchingConfig } from './matching';
export { scrambleConfig } from './scramble';
export { longAnswerConfig, shortAnswerConfig } from './written';
export { recordedConfig } from './recorded';
export { conversationalConfig } from './conversational';
export { fileUploadConfig } from './file-upload';

/**
 * Register all exercise types with the central registry.
 * This is called automatically when this module is imported.
 */
export function registerAllExerciseTypes(): void {
  exerciseRegistry.register(multipleChoiceConfig as any);
  exerciseRegistry.register(fillInBlankConfig as any);
  exerciseRegistry.register(selectForBlankConfig as any);
  exerciseRegistry.register(matchingConfig as any);
  exerciseRegistry.register(scrambleConfig as any);
  exerciseRegistry.register(longAnswerConfig as any);
  exerciseRegistry.register(shortAnswerConfig as any);
  exerciseRegistry.register(recordedConfig as any);
  exerciseRegistry.register(conversationalConfig as any);
  exerciseRegistry.register(fileUploadConfig as any);
}

// Auto-register on import
registerAllExerciseTypes();
